import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MaskedLine } from "./Ornament";

const PAGES = {
  about: {
    title: "About",
    img: "/assets/box-fortune.jpg",
    alt: "Zan-o-Box — the fortune teller, See the Future",
    teaser: "The story of B. Cooper — sculptor of the Zan-o-Boxes — is being set in type.",
  },
  history: {
    title: "History",
    img: "/assets/box-greenman.jpg",
    alt: "Zan-o-Box — relic of the old midway",
    teaser: "The rise and fall of the carnival town of Zan-o-Land, from the turn of the century through the early 1930s, is being dusted off.",
  },
  shows: {
    title: "Shows",
    img: "/assets/box-diver.jpg",
    alt: "Zan-o-Box — the deep diver and the anglerfish",
    teaser: "Future appearances of the thirty-six relics will be posted to the bill.",
  },
  zanobox: {
    title: "Zan-o-Box",
    img: "/assets/box-cat.jpg",
    alt: "Zan-o-Box — Willo-Whisker the cat",
    teaser: "All thirty-six handmade boxes are being photographed, keyed and catalogued.",
  },
};

export const ComingSoonPage = ({ page }) => {
  const cfg = PAGES[page] || PAGES.about;

  return (
    <section
      data-testid={`coming-soon-${page}`}
      className="bg-parchment-mid flex min-h-[80vh] items-center justify-center px-4 py-16 sm:px-6"
      style={{ backgroundImage: "url('/assets/parchment-bg.jpg')", backgroundSize: "cover", backgroundPosition: "top center" }}
    >
      <div className="w-full max-w-2xl text-center">
        <motion.img
          src={cfg.img}
          alt={cfg.alt}
          initial={{ opacity: 0, y: 24, rotate: -3 }}
          animate={{ opacity: 1, y: 0, rotate: -1.5 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mx-auto w-36 shadow-[0_16px_40px_rgba(40,38,32,0.35)] sm:w-44"
        />
        <h1 className="mt-10">
          <MaskedLine
            i={0}
            className="font-slab text-4xl font-bold uppercase tracking-[0.06em] text-[#5E8268] sm:text-5xl"
          >
            {cfg.title}
          </MaskedLine>
          <MaskedLine i={1} className="mt-2 font-script text-4xl text-[#4A6753] sm:text-5xl">
            Coming Soon
          </MaskedLine>
        </h1>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.55, duration: 0.6 }}
          className="mx-auto mt-6 h-px w-40 bg-[#4A6753]/50"
        />
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.65, duration: 0.7 }}
          className="mx-auto mt-6 max-w-md font-jost text-base leading-relaxed text-[#433F39]/85 sm:text-lg"
        >
          {cfg.teaser}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.85, duration: 0.7 }}
        >
          <Link
            to="/"
            data-testid={`coming-soon-${page}-home-button`}
            className="mt-10 inline-block rotate-[-1deg] border-[2.5px] border-[#5E8268] px-7 py-2.5 font-slab text-sm font-bold uppercase tracking-[0.15em] text-[#4A6753] transition-colors duration-300 hover:bg-[#5E8268] hover:text-[#F4EBDB]"
          >
            Return to Zan-o-Land
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
